module.exports = __webpack_public_path__ + "7a31ea65d416f995bd17a45bf1e68908.glb";